import React from "react";
import { Grid, MenuItem, Paper } from "@mui/material";
import { FormInput } from "../../../../components/input/FormInput";
import SelectWithServerData from "../../../../components/Select/SelectWithServerData";
import EndPoints from "../../../../utils/services/EndPoints";

const DomicilioSection = ({
  tiposDireccion,
  paperContainerClass,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  isSubmitting,
}) => {
  return (
    <Paper
      variant="outlined"
      classes={{
        root: paperContainerClass
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="idTipoDireccion"
            label="Tipo Direccion"
            value={values.idTipoDireccion}
            onChange={handleChange("idTipoDireccion")}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            select
            disabled={isSubmitting}
          >
            {tiposDireccion.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </FormInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectWithServerData
            id="idTipoVivienda"
            label="Tipo Vivienda"
            value={values.idTipoVivienda}
            onChange={handleChange("idTipoVivienda")}
            endpoint={EndPoints.listTipoVivienda}
            onBlur={handleBlur}
            helperText={touched.idTipoVivienda ? errors.idTipoVivienda : ""}
            error={touched.idTipoVivienda && Boolean(errors.idTipoVivienda)}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectWithServerData
            id="idPais"
            label="Pais"
            value={values.idPais}
            onChange={handleChange("idPais")}
            endpoint={EndPoints.getDivisionPolitica + "/1" + "/1"}
            onBlur={handleBlur}
            helperText={touched.idPais ? errors.idPais : ""}
            error={touched.idPais && Boolean(errors.idPais)}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectWithServerData
            id="idProvincia"
            label="Provincia"
            value={values.idProvincia}
            onChange={handleChange("idProvincia")}
            endpoint={EndPoints.getDivisionPolitica + "/2" + "/1"}
            onBlur={handleBlur}
            helperText={touched.idProvincia ? errors.idProvincia : ""}
            error={touched.idProvincia && Boolean(errors.idProvincia)}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectWithServerData
            id="idCiudad"
            label="Canton"
            value={values.idCiudad}
            onChange={handleChange("idCiudad")}
            endpoint={EndPoints.getDivisionPolitica + "/3" + "/2"}
            onBlur={handleBlur}
            helperText={touched.idCiudad ? errors.idCiudad : ""}
            error={touched.idCiudad && Boolean(errors.idCiudad)}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectWithServerData
            id="idParroquia"
            label="Parroquia"
            value={values.idParroquia}
            onChange={handleChange("idParroquia")}
            endpoint={EndPoints.getDivisionPolitica + "/4" + "/3"}
            onBlur={handleBlur}
            helperText={touched.idParroquia ? errors.idParroquia : ""}
            error={touched.idParroquia && Boolean(errors.idParroquia)}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="barrioComunidad"
            label="Barrio/Comunidad"
            value={values.barrioComunidad}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="direccion"
            label="Dirección"
            value={values.direccion}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="referencia"
            label="Referencia"
            value={values.referencia}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="sector"
            label="Sector"
            value={values.sector}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="telefonoConvencional"
            label="Telefono Convencional"
            value={values.telefonoConvencional}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="telefonoCelular"
            label="Telefono Celular"
            value={values.telefonoCelular}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DomicilioSection;
